/* eslint-disable no-unused-vars */
import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const AxiosRoute = () => {
  const { path } = useRouteMatch();
  return <></>;
};

export default AxiosRoute;
